// @flow
import React from 'react';
import styles from './styles.module.scss';

interface GraphP {
  width: number,
  className: string,
  label: string,
  showPercentage?: boolean,
  showTooltip?: boolean,
}

const Graph = ({
  width, className, label, showPercentage = true, showTooltip = true,
}: GraphP) => (
  width > 0 ? (
    <div
      className={`${className} ${styles.bar}`}
      style={{ width: `${width}%` }}
      role="img"
      aria-label={label}
      title={showTooltip ? label : undefined}
    >
      {showPercentage && (
        <div className={styles.spanWrap}>
          <span>{`${width}%`}</span>
        </div>
      )}
    </div>
  ) : null
);

export default Graph;
